/**
 * The accountable person shown for a process: the explicitly set accountable,
 * else the department's current manager. The fallback tracks manager changes
 * until an accountable is pinned; clearing the field returns to the fallback.
 */
export function getEffectiveAccountable<TAccountable, TManager>(
  accountable: TAccountable | null | undefined,
  departmentManager: TManager | null | undefined
): TAccountable | TManager | undefined {
  return accountable ?? departmentManager ?? undefined;
}

/**
 * Department badge for the effective accountable: an explicit accountable
 * wears their OWN department (or none — external members may have no
 * department, and an unpopulated ref must not borrow the process's); only the
 * manager fallback wears the process department they manage.
 */
export function getEffectiveAccountableDepartmentAbbreviation(
  accountable: { department?: { abbreviation?: string } | string | null } | null | undefined,
  processDepartment: { abbreviation?: string } | null | undefined
): string | undefined {
  if (accountable) {
    const department = accountable.department;
    return typeof department === 'object' && department !== null
      ? department.abbreviation
      : undefined;
  }
  return processDepartment?.abbreviation;
}
